import { Pressable } from "../../../../mads";
import { ThumbsDown } from "../../../../mads/icons/ThumbsDown";
import { useI18n } from "../../../../shared/I18n";

import { colors, spacing } from "@indeed/ifl-tokens/react-native";
import { type GestureResponderEvent, StyleSheet } from "react-native";

export type DislikeButtonProps = {
  onPressDislike: () => void;
  jobTitle?: string;
  testID?: string;
};

export function DislikeButton({ onPressDislike, jobTitle, testID }: DislikeButtonProps) {
  const i18n = useI18n();
  const accessibilityLabel = jobTitle
    ? i18n.gettext("Not Interested, {0}", [jobTitle])
    : i18n.gettext("Not Interested");

  return (
    <Pressable
      accessibilityLabel={accessibilityLabel}
      sx={({ pressed }) => [styles.dislikeButton, pressed && styles.dislikeButtonPressed]}
      onPress={(event: GestureResponderEvent) => {
        event.stopPropagation();
        event.preventDefault();
        onPressDislike();
      }}
      accessibilityRole="button"
      role="button"
      accessibilityHint={
        jobTitle
          ? i18n.gettext("{0} group. Tap to dislike the job", [jobTitle])
          : i18n.gettext("Job actions group. Tap to dislike the job")
      }
      // Keep the icon and button as one screen-reader control; otherwise the SVG can appear
      // as its own focus target and split the label from the action (same pattern as SaveButton).
      accessible={true}
      testID={testID}
    >
      <ThumbsDown variant="stroke" fill={colors.foregroundStrong} />
    </Pressable>
  );
}

const styles = StyleSheet.create({
  dislikeButton: {
    padding: 4,
    borderRadius: spacing.s6,
    justifyContent: "center",
    alignItems: "center",
  },
  dislikeButtonPressed: {
    backgroundColor: colors.backgroundStrong,
  },
});
